import {cargoApiURL} from '@logistics-frontend/client-core/api/corp'
import {fetch} from '@logistics-frontend/core/utils/network'
import {addQuery, get} from '@logistics-frontend/utils'

import {V1ClientEmployeeCardBoundContextRequest, V1ClientEmployeeCardBoundContextResponse} from '../types'

export function fetchCardTrustBindingUrl(
  clientId: string,
  body: V1ClientEmployeeCardBoundContextRequest,
  country?: string,
  makeUrl = cargoApiURL,
): Promise<string> {
  return fetch<V1ClientEmployeeCardBoundContextRequest, never, V1ClientEmployeeCardBoundContextResponse>({
    url: addQuery(makeUrl('cargo-corp/v1/client/employee/card/bound/context'), {country}),
    method: 'POST',
    headers: {
      'X-B2B-Client-ID': clientId,
    },
    body,
  }).then(get('context.binding_url'))
}
